<template>
  <OnboardingLayoutContainer>
    <LoadingScreen v-if="isLoading" />
    <div v-else :class="$style.container">
      <div :class="$style.content">
        <slot />
      </div>
    </div>
  </OnboardingLayoutContainer>
</template>

<script>
import LoadingScreen from '@/components/LoadingScreen.vue';
import OnboardingLayoutContainer from '@/pages/onboarding/components/OnboardingLayoutContainer.vue';

export default {
  components: { LoadingScreen, OnboardingLayoutContainer },
  props: {
    isLoading: Boolean,
  },
};
</script>

<style lang="less" module>
.container {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  background: @color-white;

  .content {
    margin: 0 auto;
    position: relative;
  }
}
</style>
